module.exports = __webpack_public_path__ + "img/accountantBlue.94fdfb8c.png";